@if (isMatMenu) {
  <button
    data-test="dms-trash-bin-restore-button"
    mat-menu-item
    [disabled]="buttonDisabled()"
    [matTooltip]="'label.dms.Restore' | translate"
    [matTooltipDisabled]="isMatMenu"
    (click)="restore()">
    <i class="icon fa-sm fas fa-undo"></i>
    @if(!iconOnly) {
      {{ 'label.dms.Restore' | translate }}
    }
  </button>
} @else {
  <sk-button
    data-test="dms-trash-bin-restore-button"
    [label]="'label.dms.Restore' | translate"
    [appearance]="iconOnly ? 'icon' : 'text'"
    [disabled]="buttonDisabled()"
    [matTooltip]="'label.dms.Restore' | translate"
    [matTooltipDisabled]="!iconOnly"
    (click)="restore()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="fa-fw fas fa-undo icon"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="fa-fw fas fa-undo icon"></i>
      </ng-template>
    }
  </sk-button>
}
